<template>
	<component v-bind:is="iframeModal ? 'layout-blank' : 'layout-splash'">
		<form class="h-full flex flex-col">
			<div class="bg-green-500 px-6 py-4 text-white relative">
				<div
					class="flex justify-between items-baseline pr-4 mr-6"
					v-if="step > 1"
				>
					<h1 class="text-4xl font-bold">
						{{ title }}
					</h1>
				</div>
				<div class="flex justify-between items-baseline pr-4 mr-6" v-else>
					<h1 class="text-4xl font-bold">
						{{ __("Start a new negotiation") }}
					</h1>
				</div>
				<ui-button
					type="blank"
					class="absolute right-5 top-5"
					v-if="iframeModal"
					v-on:click="closeIframeModal()"
				>
					<ui-icon class="h-9 w-9 text-white" name="x" stroke-width="2" />
				</ui-button>
			</div>

			<div v-if="step == 1">
				<admin-create-negotiation-step-1
					:data="usersList"
					:form="form"
					:other-errors="otherErrors"
					v-bind:row-on-click-handler="rowOnClickHandler"
				/>
			</div>
			<div class="overflow-y-auto" v-if="step == 2">
				<admin-create-negotiation-step-2
					:form="form"
					:offer="offer"
					:active-futures="activeFutures"
					:other-errors="otherErrors"
					:trade="trade"
				/>
				<admin-users-list :data="form.usersData" />
			</div>
			<div class="overflow-y-auto" v-if="step == 3">
				<bid-edit-step-2
					:form="form"
					:reference="offer"
					:active-futures="activeFutures"
					:trade="trade"
				/>
				<admin-users-list :data="form.usersData" />
			</div>
			<div class="bg-gray-100 px-6 pt-4 pb-6">
				<p class="text-gray-500 text-sm">
					{{ __("non_binding_advertisement_creation") }}
				</p>

				<div class="flex justify-between mt-4">
					<ui-button
						type="secondary"
						v-if="step > 1"
						v-on:click="
							() => {
								step--;
							}
						"
						label="Back"
					/>

					<ui-button
						class="ml-auto"
						v-if="step < 3"
						:disabled="nextButtonDisabled"
						v-on:click="
							() => {
								tryGotoStep(step + 1);
							}
						"
						label="Next"
					/>
					<ui-button
						class="ml-auto"
						v-else-if="!formIsInvalid"
						:disabled="submitButtonDisabled"
						v-on:click="submitForm()"
						label="Save"
					/>
				</div>
			</div>
		</form>
	</component>
</template>

<script>
let options = require("../../cropOptions");
import UiWizzard from "../../components/Ui/Wizzard.vue";
export default {
	mixins: [UiWizzard],
	props: {
		offer: {
			type: Object,
			required: true,
		},
		bid: {
			type: Object,
			required: true,
		},
		data: {
			type: Array,
			required: true,
		},
		iframeModal: {
			type: Boolean,
			default: false,
		},
		activeFutures: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			usersList: this.data.map(function (user) {
				user.checked = false;
				return user;
			}),
			step: 1,
			trade: this.offer.trade == "BUY" ? "SELL" : "BUY",
			form: Vue.observable(
				this.$inertia.form(Object.assign({ usersData: null }, this.bid))
			),
			steps: [
				{ name: "Step 1", href: "#" },
				{ name: "Step 2", href: "#" },
				{ name: "Step 3", href: "#" },
			],
			title:
				this.offer.trade == "BUY"
					? this.__("Your bid to seller")
					: this.__("Your bid to buyer"),
		};
	},
	computed: {
		nextButtonDisabled: function () {
			if (
				this.step == 1 &&
				(!this.form.usersData || this.form.usersData.length == 0)
			) {
				return true;
			}
			return false;
		},
	},
	methods: {
		rowOnClickHandler(row) {
			let users = this.usersList
				.filter((o) => o.checked)
				.map(function (o) {
					return { id: o.id, company_name: o.company_name };
				});
			this.form.usersData = users;
		},
	},
};
</script>
